import { render } from "./Promotion.vue?vue&type=template&id=a183f9b0&scoped=true"
import script from "./Promotion.vue?vue&type=script&lang=js"
export * from "./Promotion.vue?vue&type=script&lang=js"

import "./Promotion.vue?vue&type=style&index=0&id=a183f9b0&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a183f9b0"]])

export default __exports__